import React from 'react';
import Tooltip from '../../helpers/elements/tooltip.js';

const circleStyle = {
    fill: '#4867B2',
    stroke: 'rgb(29, 43, 125)',
    strokeWidth: '2px'
};

const styleValue = {
    fill: 'rgb(29, 43, 125)',
    fontWeight: 'bold',
    textAnchor: 'start',
    dominantBaseline: 'middle',
    fontSize: '1em'
};


class Bubble extends React.Component{

    constructor(props){
        super(props);

        this.onMouseOut = this.onMouseOut.bind(this);
        this.onMouseOver = this.onMouseOver.bind(this);
        this.onClick = this.onClick.bind(this);

        this.domNode = React.createRef();
    }

    onMouseOver(event){
        if(! this.domNode || ! this.domNode.current){
            return;
        }
        // let pos = getElementPagePosition(this.domNode.current);
        const item = this.props.item;

        // Tooltip.getInstance().setState({
        //     position: [Math.round(pos.left+item.radius), Math.round(pos.top)],
        //     header: false,
        //     text: item.title,
        //     anchor: 'bottom'
        // });
        this.props.onHover(item.dimension, item[item.dimension]);
    }

    onMouseOut(event){
        // Tooltip.getInstance().setState({});
        this.props.onHover(false);
    }

    onClick(event){
        event.preventDefault();
        Tooltip.getInstance().setState({});
        const item = this.props.item;
        this.props.onSelect(item.dimension, item[item.dimension]);
    }

    render(){
        const item = this.props.item;
        
        const style = {
            ...circleStyle,
            // fill: item.color,
            fill: '#fff',
            opacity: item.opacity
        };

        return <g style={{cursor: 'pointer'}} 
                onMouseOver={this.onMouseOver} 
                onMouseOut={this.onMouseOut}
                onMouseEnter={()=>this.props.onMouseEnter(item)}
                onMouseLeave={this.props.onMouseLeave}
                onClick={this.onClick} ref={this.domNode}>
            {(item.is_active) ?
                <g transform={`translate(${item.position[0] - (20/this.props.zoom)},${item.position[1] - (35/this.props.zoom)})`}>
                    <defs>
                        <filter id="a" x="0" y="0" width={45.874} height={52.821}>
                            <feOffset dy="3"/>
                            <feGaussianBlur result="blur" stdDeviation="3"/>
                            <feFlood floodOpacity={.38}/>
                            <feComposite in2="blur" operator="in" result="result1"/>
                            <feComposite in="SourceGraphic" in2="result1"/>
                        </filter>
                    </defs>
                    <g filter="url(#a)" transform={`scale(${1/this.props.zoom})`}>
                        <g transform="translate(-39.468 -28.493)" strokeLinecap="round">
                            <path d="m56.5 64.706c-0.8823 0-1.6818-0.45062-2.1386-1.2054l-4.5375-7.4963-0.06115-0.10103-0.09988-0.06299c-0.78447-0.4947-1.5178-1.0811-2.1797-1.743l-0.9369-0.9369c-2.361-2.361-3.6612-5.4999-3.6612-8.8386s1.3002-6.4776 3.6612-8.8386l0.9369-0.9369c2.361-2.361 5.5-3.6612 8.8389-3.6612 3.3389-1e-5 6.4777 1.3002 8.8382 3.6612l0.938 0.9371c2.3604 2.3608 3.6604 5.4997 3.6604 8.8384s-1.3 6.4776-3.6606 8.8386l-0.9376 0.9367c-0.49643 0.49651-1.0359 0.95299-1.6035 1.357l-0.08427 0.05997-0.05356 0.08849-4.7807 7.8981c-0.45684 0.75481-1.2563 1.2054-2.1386 1.2054z" fill="#fff"/>
                            <path d="m56.5 64.206c0.70583 0 1.3454-0.36049 1.7109-0.96434l4.7806-7.8981 0.10712-0.17698 0.16855-0.11994c0.54501-0.38786 1.063-0.82622 1.54-1.3033l0.9374-0.93649c2.2662-2.2666 3.5142-5.2799 3.5142-8.4851s-1.248-6.2186-3.5138-8.4847l-0.9382-0.93731c-2.2661-2.2665-5.2793-3.5147-8.4846-3.5147s-6.2188 1.2482-8.4854 3.5148l-0.9369 0.9369c-2.2665 2.2665-3.5148 5.2799-3.5148 8.485s1.2482 6.2185 3.5148 8.485l0.9369 0.9369c0.63564 0.63564 1.3398 1.1987 2.0928 1.6737l0.19978 0.12598 4.6598 7.6984c0.36545 0.60381 1.005 0.9643 1.7108 0.9643m0 1c-0.99135 0-1.9827-0.48217-2.5663-1.4465l-4.5374-7.4963c-0.80457-0.50738-1.5656-1.1115-2.2666-1.8124l-0.9369-0.9369c-5.0769-5.0769-5.0769-13.307 0-18.384l0.9369-0.9369c2.5384-2.5385 5.8655-3.8077 9.1925-3.8077s6.6538 1.2692 9.1918 3.8077l0.9378 0.9369c5.076 5.0769 5.076 13.307 0 18.384l-0.9378 0.9369c-0.52421 0.5243-1.0824 0.99459-1.667 1.4106l-4.7807 7.8981c-0.58365 0.96435-1.575 1.4465-2.5663 1.4465z" fill="#283583"/>
                        </g>
                        <path d="m16.94 22.312a1.888 1.888 0 0 1-1.888-1.889h3.778a1.888 1.888 0 0 1-1.89 1.889zm-6.357-4.418c0.57-0.613 1.637-1.534 1.637-4.553a4.661 4.661 0 0 1 3.776-4.58v-0.615a0.944 0.944 0 1 1 1.888 0v0.615a4.661 4.661 0 0 1 3.776 4.58c0 3.019 1.067 3.941 1.637 4.553a0.922 0.922 0 0 1 0.254 0.641 0.945 0.945 0 0 1-0.947 0.944h-11.327a0.945 0.945 0 0 1-0.947-0.944 0.922 0.922 0 0 1 0.253-0.641z" fill="#273583"/>
                    </g>
                </g>:
                <circle cx={item.position[0]} cy={item.position[1]} r={item.radius} style={style} />
            }

            {(this.props.showText) ?
                <text style={{...styleValue, ...this.props.textStyle}}>
                    <tspan x={item.position[0] + 10} y={item.position[1]}>{item.title}</tspan>
                </text> :
                null
            }
        </g>;
    }

}

export {Bubble};